import { MenuItemArgs, PickMenuItemParams } from './types';
import * as General from './util.general';
import * as Export from './util.export';
import * as Links from './util.links';
import * as Users from './util.users';
import * as Add from './util.add';

type PickMenuItem = (
  a: PickMenuItemParams,
  b: { resetActiveItem: () => void; activeItem: string; setActiveItem: (a: string) => void },
) => JSX.Element | undefined;

export const pickMenuItem: PickMenuItem = (
  { type, label, exe, divider },
  { resetActiveItem, activeItem, setActiveItem },
) => {
  const args: MenuItemArgs = { label, exe, divider, resetActiveItem, activeItem, setActiveItem };

  switch (type) {
    case 'VIEW':
      return General.VIEW(args);
    case 'PIN':
      return General.PIN(args);
    case 'CHANGE_PRIMARY_FRAMEWORK':
      return General.CHANGE_PRIMARY_FRAMEWORK(args);
    case 'PUBLISH':
      return General.PUBLISH(args);
    case 'EDIT':
      return General.EDIT(args);
    case 'DELETE':
      return General.DELETE(args);
    case 'HIDE_CONTENT':
      return General.HIDE_CONTENT(args);
    case 'VARIABLES':
      return General.VARIABLES(args);
    case 'RISK_TOLERANCE':
      return General.RISK_TOLERANCE(args);
    case 'CSV':
      return Export.CSV(args);
    case 'PDF':
      return Export.PDF(args);
    case 'EXPORT_MANAGEMENT_REPORT':
      return Export.EXPORT_MANAGEMENT_REPORT(args);
    case 'MD':
      return Export.MD(args);
    case 'DUPLICATE':
      return Export.DUPLICATE(args);
    case 'VERSION_HISTORY':
      return Export.VERSION_HISTORY(args);
    case 'UNLINK_SCENARIO':
      return Links.UNLINK_SCENARIO(args);
    case 'UNLINK_INCIDENT':
      return Links.UNLINK_INCIDENT(args);
    case 'UNLINK_CONTROL':
      return Links.UNLINK_CONTROL(args);
    case 'UNLINK_PLAN':
      return Links.UNLINK_PLAN(args);
    case 'LINK_SCENARIO':
      return Links.LINK_SCENARIO(args);
    case 'MAKE_ADMIN':
      return Users.MAKE_ADMIN(args);
    case 'REMOVE_USER':
      return Users.REMOVE_USER(args);
    case 'REMOVE_PERSON':
      return Users.REMOVE_PERSON(args);
    case 'ACCEPT_USER':
      return Users.ACCEPT_USER(args);
    case 'REJECT_USER':
      return Users.REJECT_USER(args);
    case 'CANCEL_INVITE':
      return Users.CANCEL_INVITE(args);
    case 'INVITE':
      return Users.INVITE(args);
    case 'GRANT_ACCESS':
      return Users.GRANT_ACCESS(args);
    case 'CHANGE_PERMISSIONS':
      return Users.CHANGE_PERMISSIONS(args);
    case 'ADD_TO_RMP':
      return Add.ADD_TO_RMP(args);
    case 'EXEC_SUMMARY':
      return Add.EXEC_SUMMARY(args);
    case 'OPEN_MODIFIER':
      return Add.OPEN_MODIFIER(args);
    case 'ADD_CONTROL':
      return Add.ADD_CONTROL(args);
    case 'ADD_ASSESSMENT':
      return Add.ADD_ASSESSMENT(args);
    case 'ADD_STRATEGY':
      return Add.ADD_STRATEGY(args);
    case 'ADD_INCIDENT':
      return Add.ADD_INCIDENT(args);
    case 'WIZARD':
      return Add.WIZARD(args);
    case 'WORKSPACE_VARIABLES':
      return Add.WORKSPACE_VARIABLES(args);
    case 'MARK_AS_COMPLETED':
      return Add.MARK_AS_COMPLETED(args);
    case 'ADD_ACTION':
      return Add.ADD_ACTION(args);
    case 'COMMENTS':
      return Add.COMMENTS(args);

    default:
      return undefined;
  }
};
